export class StringExtras {
  public static removeMatchingWrappingCharacters(char: string, someString: string) {
    if (someString.charAt(0) === char && someString.charAt(someString.length - 1) === char) return someString.substring(1, someString.length - 1);
    else return someString;
  }
}
